/**
 * Reads the ai_toolkit_video_edit flag straight off the server-rendered state.
 *
 * Redux state definitions run before the store exists, so they can't use a selector. Same
 * hack as ImageSearchFilterOptions. Prefer selectAiToolkitVideoEditEnabled in components.
 */
export function isAiToolkitVideoEditEnabledFromInitialState(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return Boolean(
    window.__INITIAL_STATE__?.auth?.featureFlags?.aiToolkitVideoEditEnabled
  );
}
